import { Company } from 'module/api/company/types';
import { MeetingPage } from 'api/pages/types';
import moment from 'moment';
import { useGetMeetingPagesForCompanyQuery } from 'queries/pages';
import { useMemo } from 'react';

interface Props {
  company: Company;
  searchText: string;
}
interface Result {
  meetingPages: MeetingPage[];
  allMeetingPages: MeetingPage[];
  isMeetingPagesLoading: boolean;
}
export const useMeetingPagesList = ({ company, searchText }: Props): Result => {
  const { data: meetingDocuments, isLoading } =
    useGetMeetingPagesForCompanyQuery(company.companyId);

  // If we have data (even if it's an empty array), we're not loading anymore
  // isLoading is true only when there's no data AND the query is still fetching
  const isMeetingPagesLoading = isLoading && meetingDocuments === undefined;

  const sortedMeetingDocuments = useMemo(() => {
    return (
      meetingDocuments?.sort((a, b) => {
        return moment(b.startTime).diff(moment(a.startTime));
      }) ?? []
    );
  }, [meetingDocuments]);

  const filteredMeetingDocuments = useMemo(() => {
    return sortedMeetingDocuments.filter((meeting) =>
      meeting.title?.toLowerCase().includes(searchText.toLowerCase()),
    );
  }, [sortedMeetingDocuments, searchText]);

  return {
    meetingPages: filteredMeetingDocuments,
    allMeetingPages: sortedMeetingDocuments,
    isMeetingPagesLoading,
  };
};
